import type { VariationComponent } from "~types/types";
import { filterForStoriesWithAudio } from "~utils/filterForStoriesWithAudio";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

export default function integrityCheck({
    items,
}: VariationComponent): IntegrityStatus {
    if (!items?.length) return ["Module is missing items and will not render."];

    const storiesWithAudio = filterForStoriesWithAudio(items);
    const messages = checkItemArrayIntegrity(storiesWithAudio);

    return messages;
}
